import {Pipe, PipeTransform} from '@angular/core';

const REQUEST_TYPE_ID = 173

@Pipe({ name: 'TicketIconPipe'})

export class TicketIconPipe implements PipeTransform  {

    private ticketTypeIcons = {3 : 'hdd', 82: 'file-signature'};
    private defaultIcon = 'ticket-alt';
    private requestAssistanceIon = 'tags'

    constructor(){}

    transform(value) {
        return (this.ticketTypeIcons[value]) 
          ? this.ticketTypeIcons[value]
          : (value >= REQUEST_TYPE_ID ? this. requestAssistanceIon : this.defaultIcon)

    }
}
